import { useCallback } from "react";
import { useSelector } from "react-redux";
import {
  trunkGetWorkspaceList,
  trunkGetWorkspaceDetail,
  trunkGetWorkspacePayMyList,
  trunkGetWorkspacePayMyHisList,
  trunkGetWorkspacePlanList,
  trunkCreateWorkspace,
  trunkUpdateWorkspace,
  trunkDeleteWorkspace,
  trunkGetWorkspaceMemberList,
  trunkGetWorkspaceInviteMember,
  trunkGetWorkspaceInviteAgainMembers,
  CreateWorkspaceRequestDTO,
  UpdateWorkspaceStatusRequestDTO,
  DeleteWorkspaceRequestDTO,
  workspaceMemberDTO,
  trunkSignupWorkspacMember,
  trunkUpdateWorkspaceMember,
  trunkDeleteUser,
  WorkspaceJoinDto,
  trunkVerifyMemberMail,
  trunkVerifyMemberMailAgain,
  trunkGetWorkspaceConfig,
  trunkGetWorkspaceUserInfo,
  WorkgroupMemberRequest,
} from "../store/workspace";
import { useAppDispatch, useRootState } from ".";
// # hooks
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useWorkspaceStore = () => {
  const workspaceStore = useRootState((state) => state.workspaceStore);

  const dispatch = useAppDispatch();

  const boundGetWorkspaceList = useCallback(
    () => dispatch(trunkGetWorkspaceList()).then(),
    [dispatch]
  );
  const boundGetWorkspaceDetail = useCallback(
    (dsdCode: string) => dispatch(trunkGetWorkspaceDetail(dsdCode)).then(),
    [dispatch]
  );
  const boundGetWorkspacePayMyList = useCallback(
    () => dispatch(trunkGetWorkspacePayMyList()).then(),
    [dispatch]
  );
  const boundGetWorkspacePayMyHisList = useCallback(
    () => dispatch(trunkGetWorkspacePayMyHisList()).then(),
    [dispatch]
  );
  const boundGetWorkspacePlanList = useCallback(
    () => dispatch(trunkGetWorkspacePlanList()).then(),
    [dispatch]
  );
  const boundCreateWorkspace = useCallback(
    (req: CreateWorkspaceRequestDTO) =>
      dispatch(trunkCreateWorkspace(req)).then(),
    [dispatch]
  );
  const boundUpdateWorkspace = useCallback(
    (req: UpdateWorkspaceStatusRequestDTO) =>
      dispatch(trunkUpdateWorkspace(req)).then(),
    [dispatch]
  );
  const boundDeleteWorkspace = useCallback(
    (req: DeleteWorkspaceRequestDTO) =>
      dispatch(trunkDeleteWorkspace(req)).then(),
    [dispatch]
  );
  const boundGetWorkspaceMemberList = useCallback(
    (req: WorkgroupMemberRequest) =>
      dispatch(trunkGetWorkspaceMemberList(req)).then(),
    [dispatch]
  );
  const boundGetWorkspaceInviteMember = useCallback(
    (user: workspaceMemberDTO) =>
      dispatch(trunkGetWorkspaceInviteMember(user)).then(),
    [dispatch]
  );
  const boundGetWorkspaceInviteAgainMembers = useCallback(
    (req: { userId: string; dsdCode: string }) =>
      dispatch(trunkGetWorkspaceInviteAgainMembers(req)).then(),
    [dispatch]
  );
  const boundSignupInWorkspace = useCallback(
    (req: { user: WorkspaceJoinDto; withInvitation: boolean }) =>
      dispatch(trunkSignupWorkspacMember(req)).then(),
    [dispatch]
  );
  const boundUpdateWorkspaceMember = useCallback(
    (req: workspaceMemberDTO) =>
      dispatch(trunkUpdateWorkspaceMember(req)).then(),
    [dispatch]
  );
  const boundVerifyMemberMail = useCallback(
    (userId: string) => dispatch(trunkVerifyMemberMail(userId)).then(),
    [dispatch]
  );
  const boundVerifyMemberMailAgain = useCallback(
    (userId: string) => dispatch(trunkVerifyMemberMailAgain(userId)).then(),
    [dispatch]
  );
  const boundGetWorkspaceConfig = useCallback(
    () => dispatch(trunkGetWorkspaceConfig()).then(),
    [dispatch]
  );
  const boundGetWorkspaceUserInfo = useCallback(
    (dsdCode: string) => dispatch(trunkGetWorkspaceUserInfo(dsdCode)).then(),
    [dispatch]
  );
  const boundDeleteUser = useCallback(
    (userIds: string[], dsdCode: string) =>
      dispatch(trunkDeleteUser({ userIds, dsdCode })).then(),
    [dispatch]
  );
  return {
    workspaceStore,
    getWorkspaceList: boundGetWorkspaceList,
    getWorkspaceDetail: boundGetWorkspaceDetail,
    getWorkspacePayMyList: boundGetWorkspacePayMyList,
    getWorkspacePayMyHisList: boundGetWorkspacePayMyHisList,
    getWorkspacePlanList: boundGetWorkspacePlanList,
    createWorkspace: boundCreateWorkspace,
    updateWorkspace: boundUpdateWorkspace,
    deleteWorkspace: boundDeleteWorkspace,
    getWorkspaceMemberList: boundGetWorkspaceMemberList,
    getWorkspaceInviteMember: boundGetWorkspaceInviteMember,
    getWorkspaceInviteAgainMembers: boundGetWorkspaceInviteAgainMembers,
    doSignupInWorkspace: boundSignupInWorkspace,
    deleteMember: boundDeleteUser,
    updateWorkspaceMember: boundUpdateWorkspaceMember,
    verifyMemberMail: boundVerifyMemberMail,
    verifyMemberMailAgain: boundVerifyMemberMailAgain,
    getWorkspaceConfig: boundGetWorkspaceConfig,
    getWorkspaceUserInfo: boundGetWorkspaceUserInfo,
  };
};

export default useWorkspaceStore;
